import { z } from 'zod'

/**
 * System Roles
 */
export const SYSTEM_ROLES = {
	Admin: 'Admin',
	SystemManager: 'System Manager',
	Analyst: 'Analyst',
	ReadOnly: 'Read Only',
} as const

/**
 * Role hierarchy
 */
export const ROLE_HIERARCHY = {
	'Admin': 4,
	'System Manager': 3,
	'Analyst': 2,
	'Read Only': 1,
} as const

/**
 * Zod enum for roles
 */
export const ROLES_SCHEMA = z.enum(SYSTEM_ROLES)

export const ROLES = ROLES_SCHEMA.enum
